import { Injectable } from '@angular/core';
import { Mutation } from 'apollo-angular';
import gql from 'graphql-tag';

@Injectable({
  providedIn: 'root',
})
export class CreateStripeSubscriptionMutation extends Mutation {
  document = gql`
    mutation createStripeSubscription($planId: String!) {
      createStripeSubscription(planId: $planId)
    }
  `;
}
